/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankBranchViewModel
 */
export interface BankBranchViewModel {
    /**
     * 
     * @type {string}
     * @memberof BankBranchViewModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BankBranchViewModel
     */
    branchCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankBranchViewModel
     */
    isUniversal: boolean;
}

/**
 * Check if a given object implements the BankBranchViewModel interface.
 */
export function instanceOfBankBranchViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "branchCode" in value;
    isInstance = isInstance && "isUniversal" in value;

    return isInstance;
}

export function BankBranchViewModelFromJSON(json: any): BankBranchViewModel {
    return BankBranchViewModelFromJSONTyped(json, false);
}

export function BankBranchViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankBranchViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['Name'],
        'branchCode': json['BranchCode'],
        'isUniversal': json['IsUniversal'],
    };
}

export function BankBranchViewModelToJSON(value?: BankBranchViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Name': value.name,
        'BranchCode': value.branchCode,
        'IsUniversal': value.isUniversal,
    };
}

